import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogisticsService } from '../../../../logistics/logistics.service';
import { MessageService } from '../../../services/message.service';
import { DateHelper } from '../../../helpers/date.helper';
import { Order } from '../../../models/order.model';
import { PermissionHelper } from '../../../helpers/permission.helper';
import { WorkOrderListItemPayload } from '../../../models/delivery-plan.model';

@Component({
  standalone: false,
  selector: 'app-work-order-list-modal',
  templateUrl: './work-order-list-modal.component.html',
  styleUrls: ['../modal.component.scss'],
})

export class WorkOrderListModalComponent implements OnInit {
  @Input() deliveryDeadline?: Date | null;
  @Input() isCargoAddition?: boolean;
  workOrders: Array<WorkOrderListItemPayload> = [];
  isListEmpty: boolean = false;
  selectedWorkOrder: WorkOrderListItemPayload | null = null;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private logisticsService: LogisticsService,
              private message: MessageService,
              private dateHelper: DateHelper,
              public permissionHelper: PermissionHelper
  ) {}

  ngOnInit(): void {
    this.isCargoAddition ? this.getWorkOrderListForCargo() : this.getWorkOrdersForDeliveryPlan();
  }

  getWorkOrdersForDeliveryPlan(): void {
    const formattedDeliveryDeadline = this.dateHelper.formatDateForFilter(this.deliveryDeadline);
    this.logisticsService.getDeliveryPlanWorkOrders(formattedDeliveryDeadline).subscribe(
      res => {
        this.workOrders = [];
        res.results.forEach((workOrder: WorkOrderListItemPayload) => {
          this.workOrders.push(workOrder);
        });

        this.isListEmpty = res.results.length === 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  getWorkOrderListForCargo(): void {
    const formattedDeliveryDeadline = this.dateHelper.formatDateForFilter(this.deliveryDeadline);
    this.logisticsService.getListOfWorkOrdersForCargo(formattedDeliveryDeadline).subscribe(
      res => {
        this.workOrders = [];
        res.results.forEach((workOrder: WorkOrderListItemPayload) => {
          this.workOrders.push(workOrder);
        });

        this.isListEmpty = res.results.length === 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelectWorkOrder(workOrder: WorkOrderListItemPayload): void {
    if (this.selectedWorkOrder?.workOrderId === workOrder.workOrderId) {
      this.selectedWorkOrder = null;
    } else {
      this.selectedWorkOrder = workOrder;
    }    
  }

  isEngineerIncluded(order: Order): boolean {
    return order?.jobType?.includes('Inženjerski') && order?.jobType?.length < 2;
  }

  iconToShow(order: Order): string {
    if (this.isEngineerIncluded(order)) {
      return 'fa-drafting-compass';
    } else {
      return 'fa-paint-brush';
    }
  }

  isEngineerOrGraphicConfirmed(order: Order): boolean {
    if (this.isEngineerIncluded(order)) {
      return order.engineerDocumentationCompletionDate !== null && order.engineerDocumentationCompletionDate !== undefined && order.engineerMaterialsCompletionDate !== null && order.engineerMaterialsCompletionDate !== undefined;
    } else {
      return order.graphicDocumentationCompletionDate !== null && order.graphicDocumentationCompletionDate !== undefined && order.graphicMaterialsCompletionDate !== null && order.graphicMaterialsCompletionDate !== undefined;
    }
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  onSave(): void {
    this.responseChanged.emit(this.selectedWorkOrder);
  }
}
